<template>
  <div>
    <preview-security :item="item" :action-type="actionType" @success="$emit('success', $event)" />
  </div>
</template>

<script>
import PreviewSecurity from '@/views/verification/Components/PreviewSecurity.vue'

export default {
  name: 'ApproverPreviewSecurity',
  components: { PreviewSecurity },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    actionType: {
      type: String,
      default: 'approve'
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.$set(this.item, 'loading', true)
      this.$http.get(`/approver/detailSecurity/${this.item.id}`).then(response => {
        const data = response.data
        this.item.data = data
        this.$set(this.item, 'loading', false)
      }).catch(() => {
        this.$set(this.item, 'loading', false)
      })
    }
  }
}
</script>

<style scoped>

</style>
